export function setValueForKeyPath(
  obj,
  keyPath,
  value,
  { inplace = true } = {},
) {
  const targetKeyPath = keyPath.split('.');
  if (inplace) {
    const targetKey = targetKeyPath.pop();
    let targetObj = obj;
    if (targetKeyPath.length > 0) {
      targetObj = getValueForKeyPath(obj, targetKeyPath.join('.'));
    }
    targetObj[targetKey] = value;
  } else {
    obj = Object.create(obj);
    let targetObj = obj;
    for (let i = 0; i < targetKeyPath.length - 1; ++i) {
      const targetKey = targetKeyPath[i];
      const copyObj = Object.create(targetObj[targetKey]);
      targetObj[targetKey] = copyObj;
      targetObj = copyObj;
    }
    const targetKey = targetKeyPath[targetKeyPath.length - 1];
    targetObj[targetKey] = value;
  }
  return obj;
}

export function getValueForKeyPath(obj, keyPath) {
  return keyPath.split('.').reduce((previous, current) => {
    if (previous === undefined) return undefined;
    if (current === '') return previous;
    return previous[current];
  }, obj);
}

export default {
  get: getValueForKeyPath,
  set: setValueForKeyPath,
};
